import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import CallApi from '../api/CallApi';
import { Auth } from 'aws-amplify';
import UserContext from '../contexts/UserContext';
import logger from '../utils/logger';

function Login({ onSuccessfulLogin }) {
  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();

  const { setUserData } = useContext(UserContext);
  const [loadingUserData, setLoadingUserData] = useState(false);

  let from = location.state?.from?.pathname || '/';

  const createNewUser = async () => {
    const current = await Auth.currentAuthenticatedUser();
    const method = 'POST';
    const table = 'practice_users';
    const body = {
      cognito_id: current.username,
      last_name: current.attributes.family_name,
      first_name: current.attributes.given_name,
      email: current.attributes.email,
    };
    try {
      await CallApi(method, table, body, null);
      await setUserData();
    } catch (error) {
      throw error;
    }
  };

  const handleLogin = async () => {
    setLoadingUserData(true);
    try {
      await setUserData();
    } catch (error) {
      //await createNewUser();
    } finally {
      setLoadingUserData(false);
      //console.log('login success');
      onSuccessfulLogin();
      logger.debug('Info: handle login success');
      navigate('/');
    }
  };

  // Use the shouldExecuteEffect flag to control the useEffect
  useEffect(() => {
    const checkAndHandleLogin = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        //console.log('user:', user);
        if (user) {
          await handleLogin();
        }
      } catch (error) {
        // Don't throw as this executes a few times unitl the user is authenticated
        //throw error;
      }
    };

    checkAndHandleLogin();
    if (route === 'authenticated' && !loadingUserData) {
      navigate(from, { replace: true });
    }
  }, [route]);

  return (
    <Authenticator
      loginMechanisms={['email']}
      hideSignUp={true}
      signUpAttributes={['family_name', 'given_name', 'email']}
      onAuthEvent={async (event) => {
        if (event.type === 'signIn') {
          handleLogin();
        }
      }}
    />
  );
}

export default Login;
